import { type UseParseContentForQuestionInput, useParseContentForDisplay } from './content-parser';

export function useParseContentForQuestion(params: UseParseContentForQuestionInput) {
  const { questionId } = params;
  const { parseContentForDisplay: parseContentForQuestion } = useParseContentForDisplay({
    questionId,
  });

  return {
    parseContentForQuestion,
  };
}
